import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import pathComponents from "./services/pathComponents";
import getDatos from "./services/getDatos";
import "swiper/css";
import "swiper/css/navigation";

import registrarVisita from "./services/registrarVisita";

import consultarInfoToken from "../src/services/consultarInfoToken";

import encode64 from "../src/helpers/encode64";

const root = ReactDOM.createRoot(document.getElementById("root"));

let respathData;
let rsCaractFiltro;

async function respPath() {
  respathData = await pathComponents();
  let infoToken = await consultarInfoToken();
  // console.log('respathData', respathData);
  rsCaractFiltro = await getDatos("atributos/filtroscomponentes", {
    info: encode64(JSON.stringify(infoToken)),
    super_admin: localStorage.getItem("superAdmin"),
  });

  await registrarVisita();

  root.render(
    <React.StrictMode>
      <App pathData={respathData} caractFiltro={rsCaractFiltro} />
    </React.StrictMode>
  );
}

window.respPath = respPath;

respPath();
reportWebVitals();
